import { Review } from '../../shared/models/review.model';


/**
 * Airport review/rating model
 */
export class AirportReview extends Review {
  /**
   * Airport record ID for which this record applies
   */
  airportId: number;

  /**
   * Parses review
   * @param data {any} Review data as returned by API
   * @return {AirportReview} Parsed review
   */
  static parse(data: any): AirportReview {
    const review = Review.parse(data) as AirportReview;
    review.airportId = data.airportId;
    return review;
  }
}
